import { analyticsReport } from "@dataseat-dsp-client/lib-reporter";

export const cohortWithPrevious = analyticsReport.cohortWithPrevious;

export const ANALYTICS_QUERY_MAP = analyticsReport.ANALYTICS_QUERY_MAP;
export const FILTERS_QUERY_MAP = analyticsReport.FILTERS_QUERY_MAP;
